<template>
  <div
    style="
      background: white;
      border-radius: 20px;
      width: 100%;
      height: 100%;
      position: relative;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      border: 1px solid #ddd;
    "
    :style="{
      minHeight: $vuetify.breakpoint.xl
        ? '400px'
        : $vuetify.breakpoint.lg
        ? '400px'
        : '350px',
    }"
  >
    <div
      :style="{
        display: $vuetify.breakpoint.lg ? 'block' : 'flex',
        opacity: isExceedsLimits ? 0.5 : 1,
      }"
      style="border-bottom: 1px solid #ddd; height: 50%"
    >
      <div
        :style="{
          width: $vuetify.breakpoint.lg ? '100%' : '50%',
          borderRight: $vuetify.breakpoint.lg ? 'none' : '1px solid #ddd',
          borderBottom: $vuetify.breakpoint.lg ? '1px solid #ddd' : 'none',
          height: $vuetify.breakpoint.lg ? '45%' : '',
          flexDirection:
            $vuetify.breakpoint.lg || $vuetify.breakpoint.xs ? 'row' : 'column',
        }"
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          style="display: flex; justify-content: center; align-items: center"
          :style="{
            height: $vuetify.breakpoint.lg ? '100%' : '50%',
            width: $vuetify.breakpoint.lg ? '50%' : '100%',
            borderRight: $vuetify.breakpoint.lg ? '1px solid #ddd' : 'none',
            marginTop:
              $vuetify.breakpoint.xl ||
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.sm
                ? '16px'
                : '0',
          }"
        >
          <div
            style="
              background-color: #283058;
              border-radius: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 64px;
              width: 64px;
            "
          >
            <img
              :src="logo"
              alt="Carrier Icon"
              style="
                border-radius: 100%;
                object-fit: contain;
                height: 64px;
                width: 64px;
              "
            />
          </div>
        </div>
        <div
          class="text-center"
          :style="{
            width: $vuetify.breakpoint.lg ? '50%' : '100%',
            marginBottom:
              $vuetify.breakpoint.xl ||
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.sm
                ? '16px'
                : '0',
          }"
        >
          <h3
            style="font-size: 20px; font-weight: 500"
            :style="{ marginTop: $vuetify.breakpoint.lg ? '' : '8px' }"
          >
            {{ carrierName }}
          </h3>
          <p
            style="
              color: #a3a4ab;
              font-size: 12px;
              font-weight: 500;
              margin: 0;
              padding: 0;
            "
          >
            {{ serviceType }}
          </p>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: column; justify-content: center; overflow: visible; position: relative;"
        :style="{
          height: $vuetify.breakpoint.lg ? '55%' : '',
          width: $vuetify.breakpoint.lg ? '100%' : '50%',
          alignItems: 'center',
          paddingTop: '8px',
        }"
      >
        <div
          style="
            width: max-content;
            padding: 4px 16px;
            max-width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fef1e4;
            color: white;
            border-radius: 100px;
            font-weight: 600;
            color: #fb8c01;
            box-sizing: border-box;
          "
          :style="{
            fontSize: $vuetify.breakpoint.lg ? '16px' : '20px',
          }"
        >
          {{ totalCost }} {{ currency }}
        </div>
        <div
          v-if="costBreakdown.length > 1"
          class="price-breakdown-container"
          :style="{
            display: 'flex',
            flexDirection: $vuetify.breakpoint.lg ? 'row' : 'column',
            flexWrap: $vuetify.breakpoint.lg ? 'wrap' : 'nowrap',
            gap: '4px',
            padding: '4px 8px 0 8px',
            width: '100%',
            maxHeight: '100%',
            overflow: 'visible',
            position: 'relative',
          }"
        >
          <!-- Vertical layout for larger screens (existing) -->
          <template v-if="!$vuetify.breakpoint.lg">
            <!-- Always show first 4 items -->
            <div 
              v-for="(item, index) in visibleItems" 
              :key="index"
              class="price-breakdown-item"
              :style="{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                minWidth: 0,
                maxWidth: '100%',
                marginBottom: '2px',
              }"
            >
              <div
                class="price-label"
                :style="{
                  color: '#a3a4ab',
                  fontWeight: '500',
                  fontSize: '11px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: '1',
                  marginRight: '8px',
                }"
              >
                {{ item.DisplayName || priceTypes[item.PriceType] }}
              </div>
              <div
                class="price-value"
                :style="{
                  padding: '4px 8px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#e7f2fd',
                  borderRadius: '12px',
                  fontSize: '11px',
                  fontWeight: '500',
                  color: '#2396f3',
                  minHeight: '24px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }"
              >
                {{ item.Value.toFixed(2) }} {{ currency }}
              </div>
            </div>
            
            <!-- Show three-dot menu if there are hidden items -->
            <div
              v-if="hasHiddenItems"
              @click="toggleShowAll"
              :style="{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                position: 'relative',
              }"
            >
              <div
                :style="{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  color: '#2396f3',
                  fontSize: '12px',
                  fontWeight: '500',
                }"
              >
                <span>{{ showAll ? 'Daha Az' : `+${hiddenItemsCount} Daha` }}</span>
                <v-icon 
                  :style="{ 
                    fontSize: '16px',
                    transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }"
                >
                  mdi-chevron-down
                </v-icon>
              </div>
            </div>
          </template>

          <!-- Horizontal layout for smaller screens -->
          <template v-else>
            <!-- First row: up to 4 items -->
            <div 
              v-for="(item, index) in horizontalVisibleItems" 
              :key="index"
              class="price-breakdown-item-horizontal"
              :style="{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '0',
                flex: '1',
                maxWidth: 'calc(33% - 3px)',
                marginBottom: '4px',
                padding: '4px 2px',
              }"
            >
              <div
                class="price-label-horizontal"
                :style="{
                  color: '#a3a4ab',
                  fontWeight: '500',
                  fontSize: '10px',
                  textAlign: 'center',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%',
                  marginBottom: '2px',
                }"
              >
                {{ item.DisplayName || priceTypes[item.PriceType] }}
              </div>
              <div
                class="price-value-horizontal"
                :style="{
                  padding: '4px 6px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#e7f2fd',
                  borderRadius: '8px',
                  fontSize: '10px',
                  fontWeight: '500',
                  color: '#2396f3',
                  minHeight: '22px',
                  whiteSpace: 'nowrap',
                  width: '100%',
                }"
              >
                {{ item.Value.toFixed(2) }} {{ currency }}
              </div>
            </div>

            <!-- Show more button on next row if there are hidden items -->
            <div
              v-if="hasHorizontalHiddenItems"
              @click="toggleShowAll"
              :style="{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                paddingBottom: '4px',
                width: '100%',
                position: 'relative',
              }"
            >
              <div
                :style="{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  color: '#2396f3',
                  fontSize: '11px',
                  fontWeight: '500',
                }"
              >
                <span>{{ showAll ? 'Daha Az' : `+${horizontalHiddenItemsCount} Daha` }}</span>
                <v-icon 
                  :style="{ 
                    fontSize: '14px',
                    transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }"
                >
                  mdi-chevron-down
                </v-icon>
              </div>
            </div>
          </template>
          
          <!-- Tooltip for hidden price items - positioned relative to price section -->
          <div
            v-if="showAll && (hasHiddenItems || hasHorizontalHiddenItems)"
            class="price-tooltip"
            :style="{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              zIndex: 9999,
              padding: '12px',
              marginTop: '4px',
              minWidth: '200px',
              width: '100%',
            }"
          >
            <div
              :style="{
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
              }"
            >
              <div 
                v-for="(item, index) in tooltipItems" 
                :key="'hidden-' + index"
                :style="{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  minWidth: 0,
                  maxWidth: '100%',
                }"
              >
                <div
                  :style="{
                    color: '#a3a4ab',
                    fontWeight: '500',
                    fontSize: '12px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: '1',
                    marginRight: '8px',
                  }"
                >
                  {{ item.DisplayName || priceTypes[item.PriceType] }}
                </div>
                <div
                  :style="{
                    padding: '3px 8px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#e7f2fd',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#2396f3',
                    minHeight: '22px',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                  }"
                >
                  {{ item.Value.toFixed(2) }} {{ currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 50%">
      <div :style="{
        opacity: isExceedsLimits ? 0.5 : 1,
        height: '50%'
      }">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 4px;
            height: 60%;
          "
          :style="{
            paddingLeft: $vuetify.breakpoint.lg ? '4px' : '16px',
            paddingRight: $vuetify.breakpoint.lg ? '4px' : '16px',
          }"
        >
          <div
            class="d-flex align-items-center"
            style="
              width: 45%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            <v-icon style="font-size: 18px; margin-right: 8px" color="black">
              mdi-arrow-top-right-thin-circle-outline
            </v-icon>
            <div
              style="
                font-size: 24px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ origin }}
            </div>
          </div>

          <div class="d-flex justify-center items-center" style="width: 10%">
            <img
              :src="iconPath"
              alt="Transport Icon"
              style="height: auto"
              :style="{ width: $vuetify.breakpoint.lg ? '28px' : '32px' }"
            />
          </div>

          <div
            class="d-flex align-items-center justify-end"
            style="
              width: 45%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            <v-icon style="font-size: 18px; margin-right: 8px" color="black">
              mdi-arrow-bottom-right-thin-circle-outline
            </v-icon>
            <div
              style="
                font-size: 24px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ destination }}
            </div>
          </div>
        </div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            border-bottom: 1px solid #ddd;
            height: 40%;
          "
          :style="{
            paddingLeft: $vuetify.breakpoint.lg ? '6px' : '20px',
            paddingRight: $vuetify.breakpoint.lg ? '6px' : '20px',
          }"
        >
          <div
            style="
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #4cd074;
            "
          ></div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
            "
          >
            <div
              v-for="(width, index) in greenLineWidths"
              :key="'green-' + index"
              :style="{ width: width + 'px' }"
              style="
                height: 2px;
                background-color: #dfdfdf;
                border-radius: 10px;
              "
            ></div>
          </div>
          <div style="font-size: 15px; font-weight: 500; color: #8f949a">
            {{ duration }} {{ $t("labels.day.both") }}
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
            "
          >
            <div
              v-for="(width, index) in grayLineWidths"
              :key="'gray-' + index"
              :style="{ width: width + 'px' }"
              style="
                height: 2px;
                background-color: #dfdfdf;
                border-radius: 10px;
              "
            ></div>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #c5c5c5;
            "
          >
            <div
              style="
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: #fff;
              "
            ></div>
          </div>
        </div>
      </div>

      <div
        @click="openPackageDetails"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #ddd;
          padding-left: 16px;
          padding-right: 16px;
          cursor: pointer;
          height: 30%;
        "
        :style="{ opacity: isExceedsLimits ? 0.5 : 1 }"
      >
        <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <svg
            width="24px"
            height="24px"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            color="#676a6d"
          >
            <path
              d="M2.6954 7.18536L11.6954 11.1854L12.3046 9.81464L3.3046 5.81464L2.6954 7.18536ZM12.75 21.5V10.5H11.25V21.5H12.75ZM12.3046 11.1854L21.3046 7.18536L20.6954 5.81464L11.6954 9.81464L12.3046 11.1854Z"
              fill="#676a6d"
            ></path>
            <path
              d="M3 17.1101V6.88992C3 6.65281 3.13964 6.43794 3.35632 6.34164L11.7563 2.6083C11.9115 2.53935 12.0885 2.53935 12.2437 2.6083L20.6437 6.34164C20.8604 6.43794 21 6.65281 21 6.88992V17.1101C21 17.3472 20.8604 17.5621 20.6437 17.6584L12.2437 21.3917C12.0885 21.4606 11.9115 21.4606 11.7563 21.3917L3.35632 17.6584C3.13964 17.5621 3 17.3472 3 17.1101Z"
              stroke="#676a6d"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M7.5 4.5L16.1437 8.34164C16.3604 8.43794 16.5 8.65281 16.5 8.88992V12.5"
              stroke="#676a6d"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          <div style="margin-left: 8px; font-size: 15px; font-weight: 500">
            {{ packageDetails }}
          </div>
        </div>
        <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <svg
            width="24px"
            height="24px"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            color="#676a6d"
          >
            <path
              d="M9 6L15 12L9 18"
              stroke="#676a6d"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 25%;
        "
      >
        <!-- Show exceeded limit message if limits are exceeded -->
        <div
          v-if="isExceedsLimits && exceededLimitMessage"
          style="
            background: #ffebee;
            width: 100%;
            height: 100%;
            color: #c62828;
            border-bottom-right-radius: 15px;
            border-bottom-left-radius: 15px;
            font-weight: bold;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px;
            font-size: 14px;
          "
        >
          {{ exceededLimitMessage }}
        </div>
        <!-- Show create order button if limits are not exceeded -->
        <button
          v-else
          @click="createOrder"
          :disabled="isExceedsLimits"
          :style="{
            background: '#283058',
            width: '100%',
            height: '100%',
            color: 'white',
            borderBottomRightRadius: '15px',
            borderBottomLeftRadius: '15px',
            fontWeight: 'bold',
            textAlign: 'center',
            border: 'none',
            cursor: 'pointer',
            opacity: isExceedsLimits ? 0.5 : 1
          }"
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
            "
          >
            <svg
              width="24px"
              height="24px"
              stroke-width="1.5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#ffffff"
            >
              <path
                d="M7 12.5L10 15.5L17 8.5"
                stroke="#ffffff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                stroke="#ffffff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            {{ $t("buttons.createOrder") }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logo: String,
    icon: String,
    carrierName: String,
    totalCost: Number,
    currency: String,
    costBreakdown: Array,
    origin: String,
    destination: String,
    duration: Number,
    packageDetails: String,
    transportType: Number,
    loadingType: Number,
    isExceedsLimits: Boolean,
    exceededLimitMessage: String,
  },
  data() {
    return {
      priceTypes: [],
      greenLineWidths: [5, 8, 9, 10, 10, 10, 10, 9, 8, 5],
      grayLineWidths: [5, 8, 9, 10, 10, 10, 10, 9, 8, 5],
      iconPath: "",
      serviceType: "",
      showAll: false,
    };
  },
  computed: {
    visibleItems() {
      return this.costBreakdown.slice(0, 3);
    },
    hiddenItems() {
      return this.costBreakdown.slice(3);
    },
    hasHiddenItems() {
      return this.costBreakdown.length > 3;
    },
    hiddenItemsCount() {
      return this.costBreakdown.length - 3;
    },
    // Horizontal layout computed properties
    horizontalVisibleItems() {
      return this.costBreakdown.slice(0, 3);
    },
    horizontalHiddenItems() {
      return this.costBreakdown.slice(3);
    },
    hasHorizontalHiddenItems() {
      return this.costBreakdown.length > 3;
    },
    horizontalHiddenItemsCount() {
      return this.costBreakdown.length - 3;
    },
    tooltipItems() {
      return this.costBreakdown.slice(3);
    },
  },
  mounted() {
    this.priceTypes = this.$priceTypes;
    this.getPaths(this.transportType, this.loadingType);
  },
  methods: {
    createOrder() {
      this.$emit("createOrder");
    },
    openPackageDetails() {
      this.$emit("openPackageDetails");
    },
    getPaths(transportType, loadingType) {
      if (transportType === 2) {
        this.iconPath = "/img/expressIcon.png";
        this.serviceType = this.$t("transportTypes.express");
      } else {
        switch (loadingType) {
          
          case 1:
            this.iconPath = "/img/airwayIcon.png";
            this.serviceType = this.$t("transportTypes.airline");
            break;
          case 2 || 6:
            this.iconPath = "/img/roadwayIcon.png";
            this.serviceType = this.$t("transportTypes.roadway");
            break;
          case 3:
            this.iconPath = "/img/seawayIcon.png";
            this.serviceType = this.$t("transportTypes.seaway");
            break;
          case 5:
            this.iconPath = "/img/railwayIcon.png";
            this.serviceType = this.$t("transportTypes.railway");
            break;
          case 6:
            this.iconPath = "/img/roadwayIcon.png";
            this.serviceType = this.$t("transportTypes.roadway");
            break;
          default:
            this.iconPath = "/img/airwayIcon.png";
            this.serviceType = this.$t("transportTypes.airline");
            break;
        }
      }
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
  },
};
</script>
